export interface IFuelOrder {
    id?: number;
    code?: string;
    requests?: number;
    requestsName?: string;
    authorizes?: number;
    authorizeName?: string;
    fuelType?: string;
    date?: string;
    place?: string;
    gallons?: number;
    equipmentId?: number;
    providerId?: number;
    active?: number;
    totalPrice?: number;
    gallonPrice?: number;
    billNumber?: string;
    salesOrder?: string;
    authorized?: number;
    consecutive?: number;
    equipmentBrand?: string;
    addressProvider?: string | null;
    equipmentArea?: string;
    areaId?: number;
    description?: string;
    currentOdometer?: number;
    orderOdometer?:number;
    email?: string;
    area?: string;
    type?: string;
    providerEmail?: string;
    providerName?: string;
    traccarDeviceId?: number;
  }

  export class FuelOrder  implements IFuelOrder  {
    id?: number;
    code?: string;
    requests?: number; 
    requestsName?: string;
    authorizes?: number;
    authorizeName?: string;
    fuelType?: string;
    date?: string;
    place?: string;
    gallons?: number;
    equipmentId?: number;
    providerId?: number;
    active?: number;
    totalPrice?: number;
    gallonPrice?: number;
    billNumber?: string;
    salesOrder?: string;
    authorized?: number;
    consecutive?: number;
    equipmentBrand?: string;
    addressProvider?: string | null;
    equipmentArea?: string;
    areaId?: number;
    description?: string;
    currentOdometer?: number;
    orderOdometer?:number;
    email?: string;
    area?: string;
    type?: string;
    providerEmail?: string;
    providerName?: string;
    traccarDeviceId?: number;
  }
